import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { errorMessage } from "../lib/api";
import { useAuth } from "../context/AuthContext";

/** Landing spot after Google: swaps #session_id for our own session, then carries on to where the guest was. */
export default function GoogleCallbackPage() {
  const { hash } = useLocation();
  const navigate = useNavigate();
  const { googleSession } = useAuth();
  const done = useRef(false);
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sessionId = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    const after = (() => { try { return JSON.parse(sessionStorage.getItem("google_after") || "{}"); } catch { return {}; } })();
    sessionStorage.removeItem("google_after");
    const next = typeof after.next === "string" && after.next.startsWith("/") ? after.next : "/";
    if (!sessionId) { navigate("/login", { replace: true }); return; }
    window.history.replaceState(null, "", window.location.pathname);
    googleSession(sessionId, after.ref || "")
      .then((created) => { toast.success(created ? "Welcome — your cellar is open" : "Welcome back"); navigate(next, { replace: true }); })
      .catch((e) => { toast.error(errorMessage(e)); navigate(`/login?next=${encodeURIComponent(next)}`, { replace: true }); });
  }, [hash, googleSession, navigate]);
  return <div className="grain flex min-h-screen items-center justify-center font-serif text-2xl text-neutral-500" data-testid="google-callback">Opening the cellar…</div>;
}
